/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".navbar-primary[_ngcontent-%COMP%]{position:relative;z-index:1020;background-color:#ff7000}.wrapper[_ngcontent-%COMP%]{position:relative;height:auto;max-width:30rem;text-align:center;margin:3em auto auto}"];
export { styles as styles };
